import { render, staticRenderFns } from "./startcontrol.vue.vue?vue&type=template&id=3dc3666a&scoped=true&"
import script from "./startcontrol.vue.vue?vue&type=script&lang=js&"
export * from "./startcontrol.vue.vue?vue&type=script&lang=js&"
import style0 from "./startcontrol.vue.vue?vue&type=style&index=0&id=3dc3666a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc3666a",
  null
  
)

export default component.exports